module.exports = __webpack_public_path__ + "assets/img/mask-bg3-long.1b140752.png";